import styled from "styled-components"
import {
  Descripition,
  Headline,
  StyledGradientTitle,
  animationProperties,
} from "../../../utils"
import { TeamImgProps } from "../../atoms"
import { EmployeeInformationGrid } from "../EmployeeInformationGrid"
import { AosWrapper } from "../../molecules/AosWrapper"

const EmployeeList: Array<TeamImgProps> = [
  {
    name: "Sushil Azuma",
    image: "/assets/imgs/sushil1.png",
    position: "CEO",
  },
  {
    name: "Bishal Bhattarai",
    image: "/assets/imgs/bishal-dai.png",
    position: "Branch Manager",
  },
  {
    name: "Saujanya Shrestha",
    image: "/assets/imgs/saujanya1.png",
    position: "Executive Manager",
  },
  {
    name: "Sawal Timsina",
    image: "/assets/imgs/sawal-1.png",
    position: "CTO",
  },

  {
    name: "Rageena Shrestha",
    image: "/assets/imgs/rageena-1.png",
    position: "Executive Manager",
  },
  {
    name: "Kshitiz Shrestha",
    image: "/assets/imgs/kshitiz1.png",
    position: "Team Manager",
  },
]

const Wrapper = styled.div`
  padding: 80px 20px;
  background: ${(props) => props.theme.newRadialBackground};
  @media (max-width: 1023px) {
    padding: 50px 60px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
`

const EmployeeInformation = () => {
  return (
    <Wrapper id={"information"}>
      <AosWrapper>
        <Headline>
          <StyledGradientTitle> {"Leading "}</StyledGradientTitle>
          {"with Empathy & Compassion to create \n"}
          <StyledGradientTitle> {"productive work"}</StyledGradientTitle>
          {" environment "}
        </Headline>
        <Descripition>
          {
            "We believe in professionalism, respect, and a shared commitment to excellence."
          }
        </Descripition>
        <AosWrapper
          duration={animationProperties.duration + 0.2}
          delay={animationProperties.delay + 0.2}
          animateIn={"animate__fadeInUpBig animate__zoomIn"}
        >
          <EmployeeInformationGrid items={EmployeeList} />
        </AosWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { EmployeeInformation }
